export const backgroundGradient = 'linear-gradient(46deg, #4459af 3%, #4459af 19.47%, #a060d7 99.22%)'